import React from 'react';
import { aboutInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="bg-gray-50 py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-3xl">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
            {aboutInfo.title}
          </h2>
          <div className="w-12 h-0.5 bg-gray-300 mb-8"></div>

          <p className="text-gray-600 leading-relaxed">
            {aboutInfo.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
